var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.352 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,63,162,0.05);}.b,.c,.f,.k{fill:none;}.b,.c,.d,.e,.f,.g{stroke:#003fa2;}.b,.c,.e,.g{stroke-linecap:square;}.b,.c,.e,.f,.g,.k{stroke-miterlimit:10;}.b{stroke-width:4px;}.c,.e,.f,.g{stroke-width:3px;}.d,.i{fill:#003fa2;}.e{fill:#ccd1e7;}.g{fill:rgba(0,0,0,0);}.h{fill:#0081c6;}.j{fill:#001c85;}.k{stroke:#fff;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.223,64.86H214.862l-64.712,112H31.51Z",
    transform: "translate(-31.51 -64.86)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.807 15.859)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M38.313,16H79.736V79.453H-18V16H23.42",
    transform: "translate(18 0.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.426,26.043H26V9.213A7.212,7.212,0,0,1,33.213,2h0a7.212,7.212,0,0,1,7.213,7.213Z",
    transform: "translate(15.655 -2)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 26.084,
    transform: "translate(58.99 40.994)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 26.084,
    transform: "translate(58.99 56.119)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.327,
    cy: 2.327,
    r: 2.327,
    transform: "translate(46.546 5.809)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 26.084,
    transform: "translate(58.99 48.557)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.635 32.569)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 34.906,
    height: 34.906,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M19.308,37.618v3.713L13.8,42.364A4.655,4.655,0,0,0,10,46.938V51.8",
    transform: "translate(-5.346 -16.897)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M47.308,51.8V46.938a4.654,4.654,0,0,0-3.8-4.574L38,41.33V37.617",
    transform: "translate(-17.057 -16.896)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M27.4,29.126h0c-3.534,0-6.4-4.029-6.4-7.563V20.4A6.4,6.4,0,0,1,27.4,14h0a6.4,6.4,0,0,1,6.4,6.4v1.164C33.8,25.1,30.934,29.126,27.4,29.126Z",
    transform: "translate(-9.947 -7.019)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M39.541,64.86H55.6l-8.031,13.9H31.51Z",
    transform: "translate(125.677 -51.419)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M36.662,64.86h10.3l-5.152,8.917H31.51Z",
    transform: "translate(129.995 -34.958)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M34.955,64.86h6.889L38.4,70.822H31.51Z",
    transform: "translate(115.343 -47.874)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M35.272,64.86H42.8l-3.762,6.511H31.51Z",
    transform: "translate(-12.589 23.005)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M34.205,64.86H39.6l-2.7,4.664H31.51Z",
    transform: "translate(-22.527 27.14)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.022 79.086)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M45.377,64.86H73.111l-13.867,24H31.51Z",
    transform: "translate(-31.51 -64.86)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.17 8.692)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "k",
    y2: 8,
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x2: 8,
    transform: "translate(0 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationIdentity);
export default __webpack_public_path__ + "static/media/Illustration_Identity.a008c72308d08e9da3bdd3c1044d9b68.svg";
export { ForwardRef as ReactComponent };